module.exports = "/_next/static/images/25a97ed3a725dd33d6b9a4eea7fea1b6-rewards-home-card@0.75x.png.webp";